import { useAtom } from 'jotai';
import { usePageViewed } from '@/hooks/usePageViewed';
import { onboardingAtom } from '@/pages/onboarding/state';
import type { OnboardingJourneyStep } from '@/utils/analytics/taxonomy';

// exploration_choice is the modal that closes the own-data flow. It is a stage of the same
// logical Get Started page as the four upload/build stages, so it shares this hook.
type OwnDataJourneyStep = OnboardingJourneyStep | 'exploration_choice';

export function useOnboardingPageViewed(journeyStep: OwnDataJourneyStep, enabled = true) {
  const [onboardingState] = useAtom(onboardingAtom);
  const workspace = onboardingState.workspace;

  usePageViewed({
    page_name: 'get_started',
    journey_name: 'onboarding',
    journey_step: journeyStep,
    onboarding_path: onboardingState.onboardingPath,
    entry_context: 'onboarding_own_data',
    enabled: enabled && !!workspace,
  });
}
